/* Source: /home/sidsolaiyappan/skooch_ai/scheduler/mobile_unscheduled.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useState } from "react";
import { useStoreSlice, getStoreSchedulerTasks, subscribeStoreSchedulerTasks, getStoreOverflow, subscribeStoreOverflow, getStoreSchDirty, subscribeStoreSchDirty } from "../shared/store.js";
function MobileUnscheduled(props) {
  const {callbacks} = props;
  let schCatColor = callbacks["schCatColor"];
  let _onOptimize = ((("onOptimize" in callbacks) && callbacks["onOptimize"]) ? callbacks["onOptimize"] : null);
  let schedulerTasks = useStoreSlice(getStoreSchedulerTasks, subscribeStoreSchedulerTasks);
  let overflow = useStoreSlice(getStoreOverflow, subscribeStoreOverflow);
  let schDirty = useStoreSlice(getStoreSchDirty, subscribeStoreSchDirty);
  let _op = useState(false);
  let _open = _op[0];
  let _setOpen = _op[1];
  let _isOverflow = !schDirty;
  let _items = (_isOverflow ? overflow : schedulerTasks);
  if (!_items) {
    _items = [];
  }
  if ((_items.length === 0)) {
    return null;
  }
  let _n = _items.length;
  let _label = (String(_n) + (_isOverflow ? " didn't fit" : ((_n === 1) ? " task to schedule" : " tasks to schedule")));
  let _icon = (_isOverflow ? "\u26a0\ufe0f" : "\ud83d\udccb");
  let _rows = _items.map((t, ti) => {
    let _meta = ((String(t.duration_mins) + "m \u00b7 priority ") + String(t.priority));
    return __jacJsx("div", {"key": ((("mu-" + String(t.id)) + "-") + String(ti)), "className": "mob-unsched-item"}, [__jacJsx("span", {"className": "mob-unsched-dot", "style": {"background": schCatColor(t.category)}}, []), __jacJsx("div", {"className": "mob-unsched-info"}, [__jacJsx("div", {"className": "mob-unsched-title"}, [t.title]), __jacJsx("div", {"className": "mob-unsched-meta"}, [_meta, (t.deadline ? (" \u00b7 due " + t.deadline) : "")])])]);
  });
  let _hint = (_isOverflow ? "These couldn't fit around your fixed commitments. Open Chat and ask Skooch to make room." : "Hit Optimize and Skooch will slot these around what can't move.");
  return __jacJsx("div", {"className": (_isOverflow ? "mob-unsched mob-unsched-warn" : "mob-unsched")}, [__jacJsx("button", {"className": "mob-unsched-pill", "aria-expanded": _open, "onClick": () => {
    _setOpen(!_open);
  }}, [__jacJsx("span", {"className": "mob-unsched-pill-label"}, [((_icon + "  ") + _label)]), __jacJsx("span", {"className": (_open ? "mob-unsched-chev mob-unsched-chev-open" : "mob-unsched-chev"), "aria-hidden": "true"}, ["\u2304"])]), (_open ? __jacJsx("div", {"className": "mob-unsched-body"}, [__jacJsx("div", {"className": "mob-unsched-hint"}, [_hint]), __jacJsx("div", {"className": "mob-unsched-list"}, [_rows]), ((_onOptimize && !_isOverflow) ? __jacJsx("button", {"className": "btn btn-primary mob-unsched-optimize", "onClick": () => {
    _onOptimize();
  }}, ["Optimize my week \u2192"]) : null)]) : null)]);
}
export {MobileUnscheduled};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:MobileUnscheduled": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=mobile_unscheduled.js.map
